import { t } from "adapters/i18n";
import transformerUtils from "shared/transformerUtils";
import type { OperationType, TipoMovimentacao } from "shared/types";
import type { DataResult, ServiceConstructor } from "../services.types";

export function OperationTypeServiceMixin<TBase extends ServiceConstructor>(
  Base: TBase
) {
  return class OperationTypeService extends Base {
    /**
     *  @todo change url to point to herd-service endpoint after migration
     */
    readonly operationTypeUrl = [
      `${process.env.REACT_APP_ENDPOINT}entradasaida/api/v1/`,
      "tipo-movimentacao-dicionario",
    ].join("");

    async listOperationTypes(): Promise<DataResult<OperationType>> {
      try {
        const result = await this.get(this.operationTypeUrl);

        if (result.data == null) {
          return { data: [], total: 0 };
        }

        /**
         *  @todo after migration to herd-service, remove transformation
         * and use as OperationType directly
         */
        const data = (result.data as TipoMovimentacao[]).map((item) =>
          transformerUtils.toOperationType(item)
        );

        const sortedData = data.sort((a, b) => a.name.localeCompare(b.name));
        const total = sortedData.length;

        return { data: sortedData, total };
      } catch (_) {
        throw new Error(t("movements:fetch-operation-types-error"));
      }
    }
  };
}
